/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
/** Common Components */
import CardSection from "../../../../components/ui/card/CardSection";
import FinalMolGrid from "../../../../components/FinalMolGrid/FinalMolGrid";
import ToastService from "../../../../services/toastService/ToastService";
/** CSS Files */
import "./PlanningReport.scss";
/** RTK Query */
import { useLazyGetPlanningReportByIdQuery } from "../../../../app/services/planningReportAPI";
/** Configuration Files */
import { PlanningReportGridConfig } from "./config/PlanningReport.data";

const PlanningReport = (props) => {
  const molGridRef = useRef();
  const teamId = props?.teamId;
  const planningId = props?.planningId;
  const refreshKey = props?.refreshKey ?? 0;

  // API Calls
  const [getPlanningReportById, {
    isLoading: isPlanningReportLoading,
    isFetching: isPlanningReportFetching,
    isError: isPlanningReportError,
    error: planningReportError,
    isSuccess: isPlanningReportSuccess,
    data: isPlanningReportData,
  },] = useLazyGetPlanningReportByIdQuery();

  /* State */
  const [dataSource, setDataSource] = useState([]);

  const getPlanningReport = () => {
    if (teamId && planningId) {
      getPlanningReportById({ teamId, planningId });
    }
  };

  /** useEffect's **/
  useEffect(() => {
    getPlanningReport();
  }, [teamId, planningId, refreshKey]);

  useEffect(() => {
    if (isPlanningReportSuccess && isPlanningReportData) {
      setDataSource(isPlanningReportData);
    }
  }, [isPlanningReportSuccess, isPlanningReportData]);

  useEffect(() => {
    if (isPlanningReportError) {
      ToastService.error(planningReportError?.data?.errorMessage || "Unable to load planning report.");
    }
  }, [isPlanningReportError, planningReportError]);

  const isInitialLoading = isPlanningReportLoading || (isPlanningReportFetching && !dataSource.length);

  return (<>
      <CardSection
        isContentLoading={isInitialLoading}
        hasRefreshButton={true}
        onRefresh={getPlanningReport}
      >
        {isPlanningReportError ? (
          <div className="text-center p-3">Unable to load planning report.</div>
        ) : dataSource.length === 0 && !isInitialLoading ? (
          <div className="text-center p-3">No planning report data found.</div>
        ) : (
          <div className="collapsed-plannig-grid">
            <FinalMolGrid
              ref={molGridRef}
              configuration={PlanningReportGridConfig}
              dataSource={dataSource}
              allowPagination={false}
            />
          </div>
        )}
      </CardSection>

  </>)
}

export default PlanningReport;
